const CLEAR_ALL = "CLEAR_ALL";
const SET_DATA_STEEP = "SET_DATA_STEEP";
const SET_MEMB_F_VALID = "SET_MEMB_F_VALID";
const SET_DOM_FACTURACION = "SET_DOM_FACTURACION";
const SET_DOM_RESP_PAGADOR = "SET_DOM_RESP_PAGADOR";
const SET_DATA_TARJETAS = "SET_DATA_TARJETAS";
const SET_DISABLED_BUTTON = "SET_DISABLED_BUTTON";
const SET_DATA_SELECT_PAGADOR = "SET_DATA_SELECT_PAGADOR";
const SET_DATA_INDEX_PAGADOR = "SET_DATA_INDEX_PAGADOR";
const SET_IS_FORM_NOT_READY = "SET_IS_FORM_NOT_READY";
const SET_IS_SAME_ADDRESS = "SET_IS_SAME_ADDRESS";
const SET_DATE_SCHEDULER = "SET_DATE_SCHEDULER";
const SET_ID_TIMEOUT_SCHEDULER = "SET_ID_TIMEOUT_SCHEDULER";

export {
  SET_DATA_STEEP,
  SET_MEMB_F_VALID, 
  CLEAR_ALL, 
  SET_DOM_FACTURACION, 
  SET_DOM_RESP_PAGADOR, 
  SET_DATA_TARJETAS, 
  SET_DISABLED_BUTTON, 
  SET_DATA_SELECT_PAGADOR, 
  SET_DATA_INDEX_PAGADOR, 
  SET_IS_FORM_NOT_READY, 
  SET_IS_SAME_ADDRESS,
  SET_DATE_SCHEDULER,
  SET_ID_TIMEOUT_SCHEDULER
};

function setDataSteep(data) {  
  return {
    type: SET_DATA_STEEP,
    data
  }
};

function setMembersFormValidation(payload) {  
  return {
    type: SET_MEMB_F_VALID,
    payload
  }
}

function clearAll(data)
{
  return {
    type: CLEAR_ALL
  }
}

function setDomFacturacion(data) {  
  return {
    type: SET_DOM_FACTURACION,
    hire: {
      domFacturacion: data
  }
  }
};

function setDomRespPagador(data) {  
  return {
    type: SET_DOM_RESP_PAGADOR,
    hire: {
      domRespPagador: data
  }
  }
};

function setDataTarjetas(data) {  
  return {
    type: SET_DATA_TARJETAS,
    hire: {
      tarjetas: data
  }
  }
};

function setDisabledButton(data) {  
  return {
    type: SET_DISABLED_BUTTON,
    hire: {
      disabledButton: data
  }
  }
};

function setSelectPagador(data) {  
  return {
    type: SET_DATA_SELECT_PAGADOR,
    hire: {
      selectPagador: data
  }
  }
};

function setIndexPagador(data) {  
  return {
    type: SET_DATA_INDEX_PAGADOR,
    hire: {
      indexPagador: data
  }
  }
};

function setIsFormNotReady(data) {  
  return {
    type: SET_IS_FORM_NOT_READY,
    hire: {
      isFormNotReady: data
  }
  }
};

function setIsSameAddress(data) {  
  return {
    type: SET_IS_SAME_ADDRESS,
    hire: {
      isSameAddress: data
  }
  }
};

function setDateScheduler(data) {  
  return {
    type: SET_DATE_SCHEDULER,
    hire: {
      dateScheduler: data
  }
  }
};

function setIdTimeoutScheduler(data) {  
  return {
    type: SET_ID_TIMEOUT_SCHEDULER,
    hire: {
      idTimeOutScheduler: data
  }
  }
};

const clearDataScheduler = () => (dispatch, getState) => {
  const {hire} = getState();
  clearTimeout(hire.idTimeOutScheduler);
  dispatch(setIdTimeoutScheduler(0));
  dispatch(setDateScheduler(null));
}

export {  
  setDataSteep,
  setMembersFormValidation,
  clearAll,
  setDomFacturacion,
  setDomRespPagador,
  setDataTarjetas,
  setDisabledButton,
  setSelectPagador,
  setIndexPagador,
  setIsFormNotReady,
  setIsSameAddress,
  setDateScheduler,
  setIdTimeoutScheduler,
  clearDataScheduler
}

